import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {

    notifyError,
    notifyPromise,

} from "../../../Utils/Helper";

import { ADD_WHITELABELS } from "../../Action/actionTypes";
import { addWhitelabelsFailure, addWhitelabelsSuccess } from "../../Action";


function* addWhitelabelRequest(action) {

    try {
        const formData = action?.payload?.payload;

        const promise = API.post("/create-white-label", formData);
        const res = yield call(notifyPromise, promise, "Adding Whitelabel in progress...");
        const data = res?.data;

        if (action?.payload?.callback) {
            yield call(action?.payload?.callback, data);
        }

        if (data?.meta?.code === 200) {
            yield put(addWhitelabelsSuccess(data?.data));
            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {
            yield put(addWhitelabelsFailure());
        }
    } catch (error) {


        yield put(addWhitelabelsFailure());

    }
}



export function* watchAddWhitelabelAPI() {
    yield takeEvery(ADD_WHITELABELS, addWhitelabelRequest);
}

export default function* rootSaga() {
    yield all([watchAddWhitelabelAPI()]);
}
